import React, { FC, useEffect, useState } from 'react';

import { Grid, Paper } from '@material-ui/core';
import moment from 'moment';
import EditIcon from '@material-ui/icons/Edit';

import { ISeason } from '../../../../../../store/seasons/store';

import { dateFormat } from '../../../../../../contrib/utils';
import { isSeasonCompleted } from './Utils/isSeasonCompleted';
import { EditButtonStyled } from './EditButton.Styles';
import { useBoolean } from '../../../../../common/Hooks/useBoolean.hook';
import NewSeason from '../NewSeason/NewSeason';

interface IProps {
  season: ISeason;
}

const RegisteredSeason: FC<IProps> = props => {
  const {
    season: { year, start, end, id }
  } = props;

  const [period, setPeriod] = useState('');
  const [status, setStatus] = useState('');

  const [editMode, , toggleEditMode] = useBoolean(false);

  const onEditClick = () => {
    toggleEditMode();
  };

  useEffect(() => {
    const formattedStart = moment(start, dateFormat).format('MM/DD/YY');
    const formattedEnd = moment(end, dateFormat).format('MM/DD/YY');

    setPeriod(`${formattedStart} to ${formattedEnd}`);
  }, [end, start, dateFormat]);

  useEffect(() => {
    setStatus(isSeasonCompleted(end) ? 'COMPLETED' : '');
  }, [end]);

  return editMode ? (
    <NewSeason
      hideButton={true}
      defaultValues={{ end, name: '', start, useClubIndexes: false, id }}
      hideEditionForm={toggleEditMode}
    />
  ) : (
    <Paper elevation={2} className="paper row">
      <Grid className="grid head" container={true} spacing={8} alignItems="center">
        <Grid className="grid-item" item={true} xs={3}>
          {`${year} SEASON`}
        </Grid>

        <Grid className="grid-item" item={true} xs={5}>
          {period}
        </Grid>

        <Grid className="grid-item" item={true} xs={2}>
          {status}
        </Grid>

        <Grid className="grid-item" item={true} xs={2}>
          <EditButtonStyled onClick={onEditClick} variant="text" color="primary" className="button">
            <div className="icon-container">
              <EditIcon className="edit-card-icon" />
            </div>
            EDIT
          </EditButtonStyled>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default RegisteredSeason;
